import { CommunityPrivacy } from '@lumapps/communities/types';

export enum CommunityCreationDialogSteps {
    templates = 'templates',
    microsoftGroups = 'microsoftGroups',
    settings = 'settings',
}

export interface SpaceVisibilityOption {
    privacy: CommunityPrivacy;
    name: string;
    description: string;
}
